module.exports = __webpack_public_path__ + "img/imgBaseConocimiento.30dc5843.png";